import React from "react";
import { Button, Container } from "reactstrap";

import Hero from "../../components/hero";

import { useAuth0 } from "../../react-auth0-spa";

import './styles.scss';

const Login = () => {
  const { loginWithRedirect } = useAuth0();
  const login = () => {
    loginWithRedirect({});
  };

  return (
    <div className="login">
      <Container className="flex-grow-1 mt-5">
        <Hero />
        <div className="btn-container">
          <Button
            className="btn-login"
            color="success"
            onClick={login}
          >
            Login / Sign Up
          </Button>
        </div>
      </Container>
    </div>
  )
};

export default Login;
